import * as React from "react";

const IconHeaderUserInactive: React.FC = () => {
    return (
        <svg width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
            <path
                fill="currentColor"
                d="M8 0a8 8 0 0 0-8 8 8 8 0 0 0 8 8 8 8 0 0 0 8-8 8 8 0 0 0-8-8zm0 15a6.955 6.955 0 0 1-3.975-1.245C4.153 12.215 5.431 11 7 11h2a2.994 2.994 0 0 1 2.975 2.755A6.968 6.968 0 0 1 8 15zm4.866-1.978C12.425 11.29 10.866 10 9 10H7c-1.867 0-3.425 1.29-3.866 3.023C1.821 11.722 1 9.969 1 8c0-3.86 3.14-7 7-7s7 3.14 7 7c0 1.969-.822 3.722-2.134 5.022zM8 4a2.5 2.5 0 1 0-.001 4.999A2.5 2.5 0 0 0 8 4zm0 4a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
            />
        </svg>
    );
};

export default React.memo(IconHeaderUserInactive);
